import { Button, Space } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { IconLogout } from "@tabler/icons-react";

import { useLogout } from "@/features/auth/hooks/use-logout";
import { ConfirmModal } from "@/shared/ui";

type LogoutButtonProps = {
  showLabel?: boolean;
  iconSize?: number;
};

export default function LogoutButton({ showLabel = true, iconSize = 16 }: LogoutButtonProps) {
  const [confirmOpened, { open: openConfirm, close: closeConfirm }] = useDisclosure(false);
  const { logout, isPending } = useLogout();

  return (
    <>
      <Button color="error.5" variant="transparent" size="xs" p="0" onClick={openConfirm}>
        <IconLogout size={iconSize} stroke={2} />
        {showLabel && (
          <>
            <Space w="xs" />
            خروج از حساب کاربری
          </>
        )}
      </Button>

      <ConfirmModal
        opened={confirmOpened}
        onClose={closeConfirm}
        onConfirm={logout}
        title="خروج از حساب کاربری"
        message="آیا از خروج از حساب کاربری خود اطمینان دارید؟"
        loading={isPending}
      />
    </>
  );
}
